import api from './api';

const checkDomain = async (name, id = undefined) => {
  const result = await api.post('/hosts/check-domain', { name, id });
  return result ? result.exists : false;
};

export default checkDomain;
